import React, { PureComponent } from 'react';

import { readNotifications } from '../actions/notifications';

import Discussion from './discussion';
import Message from './message';

export default class DocCommentsBlock extends PureComponent {
    handleClose = () => {
        this.props.onClose && this.props.onClose(this.props.threadId);
    }

    getLastMessage() {
        const message = this.getBlockComments()[0];

        if (!message) {
            return null;
        }

        return Object.assign({}, message, {
            text: message.text && !!message.text.match(/"text":"[^"]+"/) ? message.text : 'Attachment message'
        });
    }

    getBlockComments() {
        return this.props.allComments.filter(message => message.entity_key === this.props.entityKey);
    }

    setDiscussionCtrl = ctrl => this.discussionCtrl = ctrl;

    get notifications() {
        return this.props.notifications.filter(notification => notification.comment_data && notification.comment_data.entity_key === this.props.threadId);
    }

    componentDidUpdate(oldProps) {
        if (this.props.active) {
            readNotifications(this.notifications.map(notification => notification.id));
        }
    }

    componentDidMount() {
        this.props.provideController && this.props.provideController({
            getElement: () => {
                return this.element;
            }
        });

        this.discussionCtrl && this.discussionCtrl.focus();
    }

    render() {
        // TODO: Get last message
        // const lastMessage = this.getLastMessage();
        const lastMessage = null;

        if (!this.props.active) {
            if (lastMessage) {
                return (
                    <div
                        className={'doc-comments-block' + (this.props.hidden ? ' hidden' : '')}
                        id={`thread-block-${this.props.threadId}`}
                        ref={element => this.element = element}
                        contentEditable={false}
                        onClick={this.props.onClick}
                        onMouseEnter={this.props.onMouseEnter}
                        onMouseLeave={this.props.onMouseLeave}
                    >
                        <span className="block-icon">
                            <i className="icon ion ion-chatboxes" />
                        </span>

                        <Message
                            key={lastMessage.id}
                            text={lastMessage.text}
                            bot={lastMessage.system}
                            user={lastMessage.user}
                            createdAt={lastMessage.created_at}
                            compact={true}
                            simpleDate={true}
                        />
                    </div>
                )
            }

            return (
                <div
                    className={'doc-comments-block no-comments' + (this.props.hidden ? ' hidden' : '')}
                    id={`thread-block-${this.props.threadId}`}
                    ref={element => this.element = element}
                    contentEditable={false}
                    onClick={this.props.onClick}
                    onMouseEnter={this.props.onMouseEnter}
                    onMouseLeave={this.props.onMouseLeave}
                >
                    <i className="block-icon icon ion ion-chatboxes" />

                    <span className="no-content">Click here to add a comment</span>
                </div>
            )
        }

        return (
            <div
                className={'doc-comments-block active' + (this.props.hidden ? ' hidden' : '')}
                id={`thread-block-${this.props.threadId}`}
                ref={element => this.element = element}
                contentEditable={false}
                onMouseEnter={this.props.onMouseEnter}
                onMouseLeave={this.props.onMouseLeave}
            >
                <Discussion
                    id={this.props.threadId}
                    docId={this.props.docId}
                    type="doc"
                    inputPlaceholer="Type a comment..."
                    dateFormat="h:mma [on] MMM D"
                    noDivider={true}
                    headerEnabled={true}
                    compact={true}
                    title="COMMENTS"
                    utils={['emoji', 'file']}
                    users={this.props.docMembers}
                    provideController={this.setDiscussionCtrl}
                    onHeaderClick={this.props.onClose}
                    onClose={this.handleClose}
                />
            </div>
        )
    }
}
